import ReviewsServiceBase from "@apps/reviews/services/ReviewsServiceBase";

class ProductReviewsMiniSliderWidgetReviewsService extends ReviewsServiceBase {}

export default ProductReviewsMiniSliderWidgetReviewsService;
